import toastr from 'toastr';

export function initToastr() {
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: 'toast-bottom-right',
    preventDuplicates: true,
    onclick: null,
    showDuration: 300,
    hideDuration: 200,
    timeOut: 4000,
    extendedTimeOut: 1000,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    tapToDismiss: true,
    toastClass: 'toast toast-compact',
    titleClass: 'toast-title toast-title-compact',
    messageClass: 'toast-message toast-message-compact',
  };
}
